import { Accordion, AccordionVariant } from '@aus-platform/design-system';
import { type ComplianceRequest } from 'src/shared/api/workspace/compliance-assessment';
import { CustomDate } from 'src/shared/utils';
import { DateTimeFormatLength } from 'src/shared/utils/enums';

type GeneratedComplianceRequestItemProps = {
  complianceRequest: ComplianceRequest;
};

export const ComplianceRequestItem: React.FC<
  GeneratedComplianceRequestItemProps
> = ({ complianceRequest }) => {
  const {
    site,
    baseIteration,
    comparisonIteration,
    plannedExcavationZones,
    plannedDumpZones,
    sectionLines,
    createdAt,
    plannedExcavationQuantity,
    plannedDumpQuantity,
  } = complianceRequest;

  const formattedCreatedAt = new CustomDate(createdAt).formatDate(
    DateTimeFormatLength.Long,
  );

  return (
    <Accordion variant={AccordionVariant.ChevronRight}>
      <Accordion.Item
        title={
          <div className="compliance-request-header">
            <div className="compliance-request-header__site-name">
              {site.name}
            </div>
            <div className="compliance-request-header__requested-date">
              Requested on {formattedCreatedAt}
            </div>
          </div>
        }
        eventKey="generate-compliance-request"
      >
        <div className="compliance-request-details">
          <div>
            <div className="compliance-request-details__label">
              Active Iteration:
            </div>
            <div className="compliance-request-details__value">
              {baseIteration.name}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Comparison Iteration:
            </div>
            <div className="compliance-request-details__value">
              {comparisonIteration.name}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Planned Excavation Zones:
            </div>
            <div className="compliance-request-details__value">
              {plannedExcavationZones.map((zone) => zone.name).join(', ')}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Planned Dump Zones:
            </div>
            <div className="compliance-request-details__value">
              {plannedDumpZones.map((zone) => zone.name).join(', ')}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Section Lines:
            </div>
            <div className="compliance-request-details__value">
              {sectionLines.map((line) => line.name).join(', ')}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Planned Excavation Quantity (m<sup>3</sup>):
            </div>
            <div className="compliance-request-details__value">
              {plannedExcavationQuantity || 'N/A'}
            </div>
          </div>

          <div>
            <div className="compliance-request-details__label">
              Planned Dump Quantity (m<sup>3</sup>):
            </div>
            <div className="compliance-request-details__value">
              {plannedDumpQuantity || 'N/A'}
            </div>
          </div>
        </div>
      </Accordion.Item>
    </Accordion>
  );
};
